import { lazy } from "react";
import { RouteItem } from "../../interfaces/routes.interface";
import { ROUTES } from "../../constants/routes";

// Lazy loading components
const TrackingPreferences = lazy(() => import("../../../modules/shared/tracking-preferences"));


const trackingPreferences: RouteItem = {
    id: ROUTES.PRODUCT.tracking_preferences.key,
    path: ROUTES.PRODUCT.tracking_preferences.key,
    component: TrackingPreferences,
};

export const publicRoutes: RouteItem[] = [
    trackingPreferences,
];
